import styled from 'styled-components';
import {useCallback} from 'react';
import FieldLabel from "./field_label";

export const BareTextField = ({className, id, label, value, onChange, type='text', ...props}) => {
    const handleChange = useCallback((event) => {
        onChange(event.currentTarget.value);
    }, [onChange]);
    return (
        <div className={className}>
            {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
            <input id={id} type={type} value={value} onChange={handleChange} {...props} />
        </div>
    );
};

const TextField = styled(BareTextField)`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export default TextField;
